import { NFT, OwnedNFT } from 'src/common/types/models/Tokens'
import { big } from 'src/common/utils/big-utils'
import { Sx1155TokensQuery, UserHoldingsQuery } from '../types/sx1155/graphql'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'
import { AssetType } from '../types/swarmx/graphql'

export const normalizeSX1155Holding = (
  userHolding: UserHoldingsQuery['userHoldings'][0]
): OwnedNFT => {
  const contractAddress = unifyAddress(userHolding.tokenId.parentNFT.id)
  const tokenId = Number(userHolding.tokenId.id.split('-')[1])

  const id = unifyAddress(`${contractAddress}-${tokenId}`)

  return {
    id,
    name: userHolding.tokenId.parentNFT.name,
    symbol: userHolding.tokenId.parentNFT.symbol,
    contractAddress,
    tokenId,
    balance: big(userHolding.balance),
    logo: '',
    assetType: AssetType.Gold,
    type: 'ERC1155',
  }
}

export const normalizeAllSX1155Holdings = (
  userHoldings: UserHoldingsQuery['userHoldings']
): OwnedNFT[] => userHoldings.map(normalizeSX1155Holding)

export const normalizeSX1155Token = (
  sx155Token: Sx1155TokensQuery['sx1155TokenIds'][0]
): NFT => {
  const contractAddress = sx155Token.parentNFT.id
  const tokenId = Number(sx155Token.id.split('-')[1])

  const id = unifyAddress(`${contractAddress}-${tokenId}`)

  return {
    id,
    name: sx155Token.parentNFT.name,
    symbol: sx155Token.parentNFT.symbol,
    contractAddress: sx155Token.parentNFT.id,
    tokenId: Number(sx155Token.id.split('-')[1]),
    logo: '',
    assetType: AssetType.Gold,
    type: 'ERC1155',
  }
}

export const normalizeAllSX155Tokens = (
  sx155Tokens: Sx1155TokensQuery['sx1155TokenIds']
): NFT[] => {
  return sx155Tokens.map(normalizeSX1155Token)
}
